var menu =
    [
        {
            title: 'Dashboard',
            route: 'dashboard', 
            icon: 'HomeIcon',
        }
    ]

export default menu;
